import { useRef } from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useHandleNavClickCommunityPage } from "../../hooks/useHandleNavClick";

const awesomeMembers = [
  {
    name: "Elisha",
    position: "Project Manager",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum placeat facere mollitia",
    pics: "/images/elisha.jpg",
  },
  {
    name: "Abiodun",
    position: "Content Creator",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum placeat facere mollitia",
    pics: "/images/abiodun.jpg",
  },
  {
    name: "Rita",
    position: "Social Media Manager",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum placeat facere mollitia",
    pics: "/images/rita.jpg",
  },
];

export default function AwesomeMembersSection() {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 475,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleNavClick = useHandleNavClickCommunityPage();


  return (
    <section className="p-4 py-12 bg-secondary">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="font-bold text-primary text-3xl sm:text-4xl lg:text-5xl leading-snug mb-6 px-4">
          Meet the Awesome Members
        </h2>

        <div className="relative mt-12 px-4 sm:px-6 lg:px-8">
          <Slider ref={sliderRef} {...settings}>
            {awesomeMembers.map((member, index) => (
              <div key={index} className="px-2 sm:px-3 lg:px-4">
                <div className="bg-primary rounded-2xl shadow-md p-4 sm:p-6 text-left h-full flex flex-col mx-auto max-w-sm">
                  <p className="text-secondary text-sm sm:text-base mb-2">
                    {member.name}
                  </p>
                  <h3 className="text-secondary font-bold text-xl sm:text-2xl mb-2 leading-tight">
                    {member.position}
                  </h3>
                  {/* <p className="text-secondary text-xs sm:text-sm mb-4 leading-relaxed flex-grow">
                    {member.text}
                  </p> */}
                  <img
                    src={member.pics}
                    alt={member.name}
                    className="object-cover w-full h-80 sm:h-80 lg:h-80 rounded-2xl mt-auto"
                  />
                </div>
              </div>
            ))}
          </Slider>

          <div className="flex justify-center gap-4 sm:gap-6 mt-6 sm:mt-8">
            <button
              onClick={() => sliderRef.current?.slickPrev()}
              className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-red-500 flex items-center justify-center hover:bg-red-100 hover:border-red-600 transition-all duration-200 text-red-600 hover:text-red-700"
              aria-label="Previous slide"
            >
              <FaChevronLeft className="text-sm sm:text-base" />
            </button>
            <button
              onClick={() => sliderRef.current?.slickNext()}
              className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-red-500 flex items-center justify-center hover:bg-red-100 hover:border-red-600 transition-all duration-200 text-red-600 hover:text-red-700"
              aria-label="Next slide"
            >
              <FaChevronRight className="text-sm sm:text-base" />
            </button>
          </div>
        </div>

        <div className="mt-8 sm:mt-10 lg:mt-12 px-4">
          <button
            onClick={() => handleNavClick('/#members')}
            className="inline-block px-8 sm:px-10 lg:px-12 py-3 sm:py-4 font-semibold text-sm sm:text-base text-secondary bg-primary rounded-full hover:opacity-90 hover:scale-105 transition-all duration-200 shadow-lg"
          >
            Know Others
          </button>
        </div>
      </div>
    </section>
  );
}
